/* eslint-disable */
// @ts-ignore
import axios from 'axios';
import { getAccessToken } from './axios';
import { msalInstance } from '../main';

const GRAPH_URL = 'https://graph.microsoft.com/v1.0';

const graphAxios = axios.create({
  baseURL: GRAPH_URL,
});

graphAxios.interceptors.request.use(
  async (config) => {
    const tokenResponse = await getAccessToken(msalInstance, ['User.Read', 'User.ReadBasic.All']);

    //axios bug workaround, ref: https://github.com/axios/axios/issues/5034
    config.headers.Authorization = `Bearer ${tokenResponse}`;
    return config;
  },
  (error) => Promise.reject(error),
);

export type BasicProfile = {
  businessPhones: string[];
  displayName: string;
  givenName: string;
  jobTitle: string;
  mail: string;
  mobilePhone: string;
  officeLocation: string;
  preferredLanguage: string;
  surname: string;
  userPrincipalName: string;
  id: string;
};

export function getMe() {
  return graphAxios.get('/me').then((res) => res.data);
}

export function getAllUsers() {
  return graphAxios.get<BasicProfile>('/users').then((res) => res.data);
}

export function getUsers(filterText = '', top = 25): Promise<BasicProfile[]> {
  const searchClause = filterText ? `$search="displayName:${filterText}" OR "mail:${filterText}"&` : ``;
  return (
    graphAxios
      .get(`/users?${searchClause}$orderby=displayName&$top=${top}`, {
        headers: {
          ConsistencyLevel: 'eventual',
        },
      })
      .then((res) => (res.data?.value || []) as BasicProfile[])
      // filter only user accounts
      .then((users) => users.filter((u) => u.mail))
  );
}

export async function getUserByEmail(email: string): Promise<BasicProfile> {
  if (!email) throw new Error('Email not provided');

  const searchClause = `$filter=endswith(mail,'${email}')&$count=true`;
  return graphAxios
    .get(`/users?${searchClause}`, {
      headers: {
        ConsistencyLevel: 'eventual',
      },
    })
    .then((res) => res.data?.value[0] as BasicProfile);
}
